import { render, staticRenderFns } from "./tip-tap.vue?vue&type=template&id=f0d017a6&scoped=true&"
import script from "./tip-tap.vue?vue&type=script&lang=js&"
export * from "./tip-tap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d017a6",
  null
  
)

export default component.exports